// Copyright (c) 2022 Sagacity Solutions Inc. All right reserved.
'use strict'        ;

import HTTP from './http-server';

export default {
  fetchReportSection: async function() {
    const response = await HTTP.get('v1/settings/system/reportsection');
    if (response.status == 200) {
      return response.data;
    }
  },
  updateReportSection: async function(data) {
    const response = await HTTP.post('v1/settings/system/reportsection', data);
    if (response.status == 200) {
      return response.data;
    }
  },
  fetchSectionContent: async function() {
    const response = await HTTP.get('v1/settings/system/sectioncontent');
    if (response.status == 200) {
      return response.data;
    }
  },
  updateSectionContent: async function(data) {
    const response = await HTTP.post('v1/settings/system/sectioncontent', data);
    if (response.status == 200) {
      return response.data;
    }
  },
  fetchSmsMessage: async function() {
    const response = await HTTP.get('v1/settings/system/smsmessage');
    if (response.status == 200) {
      return response.data;
    }
  },
  updateSmsMessage: async function(data) {
    const response = await HTTP.post('v1/settings/system/smsmessage', data);
    if (response.status == 200) {
      return response.data;
    }
  }
}
